function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
export var visitExit = Symbol('exit');
export var visitSkip = Symbol('skip');
export var Nodes;
(function (_Nodes) {
  function visitNode(node, visitor, parentNode) {
    var _parentNode$children;
    var callbacks = visitor['element'];
    var symbol;
    if (callbacks && callbacks.enter) {
      symbol = callbacks.enter(node, parentNode);
      if (symbol === visitSkip || symbol === visitExit) {
        return symbol;
      }
    }
    // visit element children if still attached to parent
    if (!parentNode || (_parentNode$children = parentNode.children) !== null && _parentNode$children !== void 0 && _parentNode$children.includes(node)) {
      //copy children array to not loose cursor when children is spliced
      var children = node.children;
      if (children) {
        var _iterator = _createForOfIteratorHelper(children),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var child = _step.value;
            symbol = visitNode(child, visitor, node);
            if (symbol === visitExit) {
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
    if (callbacks && callbacks.exit) {
      callbacks.exit(node, parentNode);
    }
    if (symbol === visitExit) {
      return symbol;
    }
  }
  _Nodes.visitNode = visitNode;
  function visit(nodes, visitor) {
    if (Array.isArray(nodes)) {
      var _iterator2 = _createForOfIteratorHelper(nodes),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _node = _step2.value;
          var symbol = visitNode(_node, visitor);
          if (symbol === visitExit) {
            return symbol;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    } else {
      return visitNode(nodes, visitor);
    }
  }
  _Nodes.visit = visit;
  function visit2(nodes, visitor) {
    if (Array.isArray(nodes)) {
      var _iterator3 = _createForOfIteratorHelper(nodes),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _node2 = _step3.value;
          var symbol = visitNode(_node2, visitor);
          console.log(_node2, symbol);
          if (symbol === visitExit) {
            return symbol;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    } else {
      return visitNode(nodes, visitor);
    }
  }
  _Nodes.visit2 = visit2;
})(Nodes || (Nodes = {}));